/*
This hook handles functionality for a sticky menu expand button
and takes into account expand button click and scroll change when menu is expanded
*/

import { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';

export const useExpandButtonOnStickyMenu = (scrollOffset = 100) => {
  const currentScroll = useRef(0);
  const [shouldExpandStickyMenu, setShouldExpandStickyMenu] = useState(false);

  const expandStickyMenu = () => {
    currentScroll.current = window.scrollY;
    setShouldExpandStickyMenu(true);
  };

  useEffect(() => {
    const throttledHandleOnScroll = throttle(handleOnScroll, 300);

    window.addEventListener('scroll', throttledHandleOnScroll);

    return () => {
      window.removeEventListener('scroll', throttledHandleOnScroll);
    };

    function handleOnScroll() {
      const shouldCollapseNavigation =
      currentScroll.current > window.scrollY + scrollOffset ||
      currentScroll.current < window.scrollY - scrollOffset;

      shouldCollapseNavigation && setShouldExpandStickyMenu(false);
    }
  });

  return {
    shouldExpandStickyMenu,
    expandStickyMenu,
  };
};
